module.exports = __webpack_public_path__ + "static/img/client_upgraded_en1.3938a904.png";